import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { BsrmhttpService } from '../../services/bsrmhttp.service';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { Authdata } from 'src/app/classes/authdata.class';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  // type: string ;
  key : string;
  message: string;

  constructor(private globalServices: GlobalService, private http: BsrmhttpService, 
    private route: ActivatedRoute, private router : Router) { 
    this.route.queryParams.subscribe(paramList=>{
      this.key = paramList['key'];
      var param = {key : this.key };
      this.http.get(this.globalServices.redirectApi, param).subscribe(d=>{
        var json = JSON.parse(JSON.stringify(d));

        var authData = new Authdata();
        authData.setData(json.Token);

        var token = JSON.parse(json.Token);

        this.globalServices.ApplicationList = undefined;
        var responsibilities = JSON.parse(token.RSP);
        console.log(responsibilities);
        console.log(responsibilities[0]);
        console.log(responsibilities[0].RSPID);
        sessionStorage.removeItem(this.globalServices.applicationListName);
        
        if(responsibilities.length == 1){
              sessionStorage.setItem(this.globalServices.selectedResponsibilityKey, responsibilities[0].RSPID);
              if(json.Parameter && json.Parameter.length >0){
                this.router.navigateByUrl(json.Route+'?'+json.Parameter);
              }
              else{
                this.router.navigate([json.Route]);
              }
            }
            else if(responsibilities.length > 1){
              //show modal for selected and set it to session storage and then navigate.
              sessionStorage.setItem(this.globalServices.selectedResponsibilityKey, responsibilities[0].RSPID);
              console.log('selected responsibilities');
              console.log(responsibilities[0].RSPID);

              if(json.Parameter && json.Parameter.length >0){
                this.router.navigateByUrl(json.Route+'?'+json.Parameter);
              }
              else{
                this.router.navigate([json.Route]);
              }
            }
            else{
              this.message = "You are not authorized to access this application.";
            }
      });
    });
  }

  ngOnInit() {
    console.log(this.key);
  }
}
